module.exports = __webpack_public_path__ + "resources/img/img_security_TLS_SSL_certificate2_en.0f404e761a9f03e181032efd60019314.png";